import styled from 'styled-components'
import UiButton from '../../../../../components/Button'

export const Field = styled('div')``
export const Container = styled('div')``
export const Error = styled('div')``
export const Label = styled('label')``
export const CouponNumber = styled('div')`
  height: 43px;
  border-radius: 20px;
  border: 2px solid #12B47A;
  color: #12B47A;
  font-size: 14px;
  font-weight: bold;
  width: 100%;
  max-width: 206px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`

export const Button = styled(UiButton)`
  padding: 0px;
  font-weight: 500;
  font-size: 14px;
  line-height: 33px;
  position: relative;
  text-decoration: none;
  gap: 8px;

  &:hover {
    text-decoration: none;
  }

  &:after {
    content: '';
    display: block;
    height: 2px;
    background-color: #6C5CE7;
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0px;
  }
`;